import $ from 'jquery';
import '../class/sk';
import '../class/sk.widgets.Carousel';
import '../class/sk.widgets.Pager';

const carousel = () => {

	$('.carousel')
		.each(function(){
			var $box = $(this),
				$scroll = $box.find('.carousel__list'),
				$pager = $box.find('.carousel__pager');
				// $prev = $box.find('.carousel__prev'),
				// $next = $box.find('.carousel__next');

			new sk.widgets.Carousel($scroll, {
				item: '.carousel__item',
				timeout: $scroll.data('timeout') ? $scroll.data('timeout') : 0,
				infinite: $scroll.data('infinite') ? true : false,
				fullscreen: $scroll.data('fullscreen') ? true : false,
				pagerPages: $pager,
				scroll: 3,
				// pagerPrev: $prev,
				// pagerNext: $next
			}).init();
		});

	$('.b-gallery')
		.each(function(){
			var $box = $(this),
				$scroll = $box.find('.b-gallery__main'),
				$pager = $box.find('.b-gallery__pages'),
				$pager2 = $box.find('.b-gallery__link'),
				$prev = $box.find('.b-gallery__prev'),
				$next = $box.find('.b-gallery__next');

			var carousel = new sk.widgets.Carousel($scroll, {
				item: '.b-gallery__main__item',
				timeout: 0,
				infinite: false,
				fullscreen: true,
				pagerPages: $pager,
				pagerPrev: $prev,
				pagerNext: $next,
				onChange: function(obj){
					$pager2
						.removeClass('active')
						.eq(obj.position).addClass('active');
				}
			}).init();

			$pager2.on('click', function(e){
				e.preventDefault();

				var $this = $(this);

				carousel.setPosition($this.parent().index(), true);

			});
		});

	$('.js-hero')
		.each(function(){
			var $box = $(this),
				$scroll = $box.find('.c-top-articles__list'),
				$pager = $box.find('.c-top-articles__paging a');

			var carousel_hero = new sk.widgets.Carousel($scroll, {
				item: '.c-top-articles__item',
				timeout: 5000,
				infinite: true,
				fullscreen: true,
				scroll: 1,
				onChange: function(obj){
					$pager
						.removeClass('is-active')
						.eq(obj.position).addClass('is-active');
				}
			}).init();

			$pager.on('click', function(e) {
				e.preventDefault();
				var $this = $(this);
				var index = $this.index();
				carousel_hero.setPosition(index, true);
			});

		});

};

exports.init = carousel;



// WEBPACK FOOTER //
// ./src/js/components/carousel.js